module.exports = __webpack_public_path__ + "static/media/2-10.3b25dc04.mp3";